import { dateFormat } from "helpers/dates";
import moment from "moment";

export const parseDate = (date?: string): Date =>
    !date ? null : moment(date, dateFormat.YEAR_MONTH_DAY, true).toDate();
